import { render, staticRenderFns } from "./ListadoPrincipalPedidos.vue?vue&type=template&id=1992ac6d&scoped=true"
import script from "./ListadoPrincipalPedidos.vue?vue&type=script&lang=js"
export * from "./ListadoPrincipalPedidos.vue?vue&type=script&lang=js"
import style0 from "./ListadoPrincipalPedidos.vue?vue&type=style&index=0&id=1992ac6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1992ac6d",
  null
  
)

export default component.exports